export {TaskAssignmentComponent as TaskAssignment} from  './TaskAssignmentComponent';



// WEBPACK FOOTER //
// ./src/js/tasks/components/TaskAssignment/index.js